"use strict";
/**
 * @module "ethpm/storage"
 */
Object.defineProperty(exports, "__esModule", { value: true });
